import Mock from './Mock';

export default class MemberServiceMock {
  static getCurrentMember() {
    return Mock.call({
      memberGuid: '034c6b0e-3712-4dbf-888b-835dd77df723',
      firstName: 'Test',
      lastName: 'Member',
      isActive: true,
      language: 'fr',
      hasContactInformation: true,
    });
  }

  static changeLanguage() {
    return Mock.call();
  }

  static getCurrentMemberContactInformation() {
    return Mock.call();
  }

  static getCurrentProfilePicture() {
    return Mock.call({ id: 33 });
  }

  static saveProfilePicture() {
    return Mock.call();
  }

  static getCurrentMemberCalendarPreferences() {
    return Mock.call([
      {
        name: 'CALENDAR_DISPLAY_SETTINGS.TIME_SHEET',
        value: true,
      },
      {
        name: 'CALENDAR_DISPLAY_SETTINGS.HOLIDAY',
        value: false,
      },
      {
        name: 'CALENDAR_DISPLAY_SETTINGS.EVENT',
        value: true,
      },
      {
        name: 'CALENDAR_DISPLAY_SETTINGS.TRAINING',
        value: false,
      },
    ]);
  }

  static saveCalendarPreferences() {
    return Mock.call();
  }

  static getCurrentMemberNotificationPreferences() {
    return Mock.call([
      {
        notifiableElementId: 1,
        notifiableElementName: 'NOTIFIABLE_ELEMENT_TYPE.TIME_SHEET',
        isSubscribed: true,
        notficationTypeSubscriptions: [
          {
            notficationTypeId: 1,
            notficationTypeName: 'NOTIFICATION_TYPE.SMS',
            isSubscribed: false,
          },
          {
            notficationTypeId: 2,
            notficationTypeName: 'NOTIFICATION_TYPE.EMAIL',
            isSubscribed: true,
          },
          {
            notficationTypeId: 3,
            notficationTypeName: 'NOTIFICATION_TYPE.PUSH',
            isSubscribed: false,
          },
        ],
      },
      {
        notifiableElementId: 2,
        notifiableElementName: 'NOTIFIABLE_ELEMENT_TYPE.EVENT',
        isSubscribed: false,
        notficationTypeSubscriptions: [
          {
            notficationTypeId: 1,
            notficationTypeName: 'NOTIFICATION_TYPE.SMS',
            isSubscribed: false,
          },
          {
            notficationTypeId: 2,
            notficationTypeName: 'NOTIFICATION_TYPE.EMAIL',
            isSubscribed: false,
          },
          {
            notficationTypeId: 3,
            notficationTypeName: 'NOTIFICATION_TYPE.PUSH',
            isSubscribed: false,
          },
        ],
      },
      {
        notifiableElementId: 3,
        notifiableElementName: 'NOTIFIABLE_ELEMENT_TYPE.TRAINING',
        isSubscribed: false,
        notficationTypeSubscriptions: [
          {
            notficationTypeId: 1,
            notficationTypeName: 'NOTIFICATION_TYPE.SMS',
            isSubscribed: false,
          },
          {
            notficationTypeId: 2,
            notficationTypeName: 'NOTIFICATION_TYPE.EMAIL',
            isSubscribed: false,
          },
          {
            notficationTypeId: 3,
            notficationTypeName: 'NOTIFICATION_TYPE.PUSH',
            isSubscribed: false,
          },
        ],
      },
      {
        notifiableElementId: 4,
        notifiableElementName: 'NOTIFIABLE_ELEMENT_TYPE.JOBS',
        isSubscribed: true,
        notficationTypeSubscriptions: [
          {
            notficationTypeId: 1,
            notficationTypeName: 'NOTIFICATION_TYPE.SMS',
            isSubscribed: false,
          },
          {
            notficationTypeId: 2,
            notficationTypeName: 'NOTIFICATION_TYPE.EMAIL',
            isSubscribed: false,
          },
          {
            notficationTypeId: 3,
            notficationTypeName: 'NOTIFICATION_TYPE.PUSH',
            isSubscribed: true,
          },
        ],
      },
    ]);
  }

  static saveNotificationPreferences() {
    return Mock.call();
  }

  static getCurrentMemberEmployment() {
    return Mock.call({
      hasJob: false,
    });
  }

  static saveEmployment() {
    return Mock.call();
  }

  static getCurrentMemberSubscriptionPreferences() {
    return Mock.call([
      {
        newsletterId: 1,
        newsletterTitle: 'Infolettre',
        newsletterDescription: null,
        isSubscribed: true,
      },
      {
        newsletterId: 2,
        newsletterTitle: 'Infolettre de la relève',
        newsletterDescription: null,
        isSubscribed: true,
      },
    ]);
  }

  static saveSubscriptionPreferences() {
    return Mock.call();
  }

  static changePassword() {
    return Mock.call();
  }

  static saveContactInformation() {
    return Mock.call();
  }

  static getCurrentMemberEmployers() {
    return Mock.call();
  }

  static getCurrentMemberEmployer() {
    return Mock.call();
  }

  static saveCurrentMemberEmployer() {
    return Mock.call();
  }

  static addCurrentMemberEmployer() {
    return Mock.call();
  }

  static deleteCurrentMemberEmployer() {
    return Mock.call();
  }

  static updateCurrentMemberPlacement() {
    return Mock.call();
  }

  static getCurrentMemberPlacements() {
    return Mock.call({
      items: [
        {
          memberGuid: 'string',
          date: '2018-11-13T20:26:15.671Z',
          message: 'string',
          employeur: {
            ccqNumber: 0,
            name: 'string',
            email: 'string',
            address: {
              street: 'string',
              appartment: 'string',
              city: 'string',
              postalCode: 'string',
              provinceCode: 'string',
              countryCode: 'string',
            },
            phoneNumbers: [
              {
                number: 'string',
                extension: 'string',
                type: 'string',
              },
            ],
          },
          representative: {
            officeId: 0,
            firstName: 'string',
            lastName: 'string',
            email: 'string',
            id: 0,
          },
        },
        {
          memberGuid: 'string',
          date: '2018-11-13T20:26:15.671Z',
          message: 'string',
          employeur: {
            ccqNumber: 0,
            name: 'string',
            email: 'string',
            address: {
              street: 'string',
              appartment: 'string',
              city: 'string',
              postalCode: 'string',
              provinceCode: 'string',
              countryCode: 'string',
            },
            phoneNumbers: [
              {
                number: 'string',
                extension: 'string',
                type: 'string',
              },
            ],
          },
          representative: {
            officeId: 0,
            firstName: 'string',
            lastName: 'string',
            email: 'string',
            id: 0,
          },
        },
        {
          memberGuid: 'string',
          date: '2018-11-13T20:26:15.671Z',
          message: 'string',
          employeur: {
            ccqNumber: 0,
            name: 'string',
            email: 'string',
            address: {
              street: 'string',
              appartment: 'string',
              city: 'string',
              postalCode: 'string',
              provinceCode: 'string',
              countryCode: 'string',
            },
            phoneNumbers: [
              {
                number: 'string',
                extension: 'string',
                type: 'string',
              },
            ],
          },
          representative: {
            officeId: 0,
            firstName: 'string',
            lastName: 'string',
            email: 'string',
            id: 0,
          },
        },
      ],
      totalCount: 0,
    });
  }

  static authenticationValidate(args) {
    const response = {
      email: 'testmember2@example.com',
      firstName: 'Test',
      isActive: true,
      lastName: 'Member 2',
      memberGuid: '034c6b0e-3712-4dbf-888b-835dd77df723',
    };
    console.log('MOCK CALL: authenticationValidate');
    console.log(args);
    console.log(response);

    return Mock.call(response);
  }

  static authenticationCreate() {
    const response = {
      email: 'testmember2@example.com',
      memberGuid: '034c6b0e-3712-4dbf-888b-835dd77df723',
    };
    console.log('MOCK CALL: authenticationCreate');
    console.log(response);
    return Mock.call(response);
  }
}
